import { BaseFilters } from "./base-filter-model";
import { TopLevelHierarchy, H7Agreement, Customer } from "./ebr-models";

export class Filters extends BaseFilters {
    topLevelHierarchies: TopLevelHierarchy[] | undefined;
    h7Agreements: H7Agreement[] | undefined;
    customers: Customer[] | undefined;
    thirdLevelContractFilter?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;

    constructor(
        regions?: string[],
        countries?: string[],
        period?: string,
        excludeDeletedAccounts?: boolean,
        topLevelHierarchies?: TopLevelHierarchy[],
        h7Agreements?: H7Agreement[],
        customers?: Customer[],
        presentationType?: string,
        translation?: string,
        dateRange?: string,
        thirdLevelContractFilter?: string[],
    ){
        super(regions, countries, period, presentationType, translation,dateRange);
        this.topLevelHierarchies = topLevelHierarchies;
        this.h7Agreements = h7Agreements;
        this.customers = customers;
        this.thirdLevelContractFilter = thirdLevelContractFilter;
        this.excludeDeletedAccounts = excludeDeletedAccounts;
    }

    override toString(): string{
        return `${super.toString()},
                topLevelHierarchies=${this.topLevelHierarchies}, 
                h7Agreements=${this.h7Agreements},
                customers=${this.customers},
                thirdLevelContractFilter=${this.thirdLevelContractFilter}`;
    }
}

export interface RollingTimePeriod {
  $type: 'RollingTimePeriod';
  Kind: string;
}

export interface FixedTimePeriod {
  $type: 'FixedTimePeriod';
  DateRange: {
    Start: {
      Year: number;
      Month: number;
    };
    End: {
      Year: number;
      Month: number;
    };
  };
}

export type TimePeriod = RollingTimePeriod | FixedTimePeriod;


export interface FilterSet {
  $type: string;   // discriminator
  Period: TimePeriod;
  Regions: string[];
  Countries: string[];
  Template: string;
  ExcludeDeletedAccounts?: boolean;
  CurrencyCode?: string;
  UnitOfMeasure?: string;
}

export interface InstitutionalFilterSet extends FilterSet {
  TopLevelContractGroups: string[];
  SecondLevelContracts: string[];
  AccountNumbers: string[];
}

export interface QsrFilterSet extends FilterSet {
  TopLevelContractGroups: string[];
  SecondLevelContracts: string[];
  AccountNumbers: string[];
}

export interface FrsFilterSet extends FilterSet {
  TopLevelContractGroups: string[];
  SecondLevelContracts: string[];
  AccountNumbers: string[];
}

export interface PestFilterSet extends FilterSet {
  TopLevelContractGroups: string[];
  SecondLevelContracts: string[];
  AccountNumbers: string[];
}

export interface CustomerFilterSet extends FilterSet {
  TopLevelCustomerNames: string[];
  SubBrands: string[];
  CustomerNumbers: string[];
}

export interface DistributorFilterSet extends FilterSet {
  PartnerGroups: string[];
  DistributorGroups: string[];
  DistributorNumbers: string[];
}

// Matches the backend's OneCustomerFilterSet ($type discriminator "OneCustomerFilterSet"), used for 1C-redirected users.
export interface OneCustomerFilterSet extends FilterSet {
  Division: string;
  CustomerName: string;
  OperatingType?: string;
  OperatingSubType?: string[];
  CustomerGroup?: unknown;
  EcolabGroup?: unknown;
  CustomerIndustry?: unknown;
  Campuses?: string[];
  Sites?: string[];
}
